import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchTasks } from '../../redux/slices/tasksSlice';
import TaskList from './TaskList';
import TaskEditor from './TaskEditor';
import TaskStats from './TaskStats';
import './TaskConstructor.css';

export default function TaskConstructor() {
    const dispatch = useAppDispatch();
    const panel = useAppSelector((state) => state.tasks.panel);
    const selectedTask = useAppSelector((state) =>
        state.tasks.items.find((t) => t.key === state.tasks.selectedKey)
    );

    useEffect(() => {
        dispatch(fetchTasks());
    }, [dispatch]);

    let content;
    if (!selectedTask) {
        content = <p className="task-hint task-hint--center">Выберите задание слева или создайте новое</p>;
    } else if (panel === 'stats' && selectedTask.id != null) {
        content = <TaskStats task={selectedTask} />;
    } else {
        content = <TaskEditor task={selectedTask} />;
    }

    return (
        <div className="task-constructor">
            <TaskList />
            <section className="task-workspace">{content}</section>
        </div>
    );
}
